/*
 *
 * Home constants
 *
 */

// LOAD
export const LOAD_HOME = 'app/Home/LOAD_HOME';
export const LOAD_HOME_SUCCESS = 'app/Home/LOAD_HOME_SUCCESS';
export const LOAD_HOME_ERROR = 'app/Home/LOAD_HOME_ERROR';

// CHANGE/UPDATE
export const CHANGE_HOME = 'app/Home/CHANGE_HOME';
export const CHANGE_HOME_SUCCESS = 'app/Home/CHANGE_HOME_SUCCESS';
export const CHANGE_HOME_ERROR = 'app/Home/CHANGE_HOME_ERROR';

// DELETE
export const DELETE_HOME = 'app/Home/DELETE_HOME';
export const DELETE_HOME_SUCCESS = 'app/Home/DELETE_HOME_SUCCESS';
export const DELETE_HOME_ERROR = 'app/Home/DELETE_HOME_ERROR';

export const FLUSH_STATE_HOME = 'app/Home/FLUSH_STATE_HOME';
